export const unSupportTips = {
  en:
    'Oops! Your phone\'s operating system or WeChat version is out of date . Please install the latest version in order to view it.',
  'zh-cn': '你需要更新系统或WeChat至最新版本后才能打开噢！',
  'zh-hk': '你需要更新系統或WeChat至最新版本後才能打開噢！',
};
